import React, { useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { doc, onSnapshot, updateDoc, collection, collectionGroup, query, where, setDoc, getDocs, deleteDoc, serverTimestamp } from 'firebase/firestore';
import JogoPK from './JogoPK';
import Perfil from './Perfil';
import { dispararPushNoBolso } from './backendNotificacoes';
import { enviarNotificacao } from './notificacoesService';
import { terminarTodasAsSessoes } from './agoraSession';

function ArenaPK({ batalhaId, aoSair }) {
  const [arenaFechadaLocal, setArenaFechadaLocal] = useState(false);
  const [meusDados, setMeusDados] = useState(null);
  const [utilizadoresOnline, setUtilizadoresOnline] = useState([]);
  const [batalhaAtiva, setBatalhaAtiva] = useState(null);
  const [modoEspectador, setModoEspectador] = useState(false);
  const [meusBloqueados, setMeusBloqueados] = useState([]);
  const [pesquisaArena, setPesquisaArena] = useState("");
  const [quemMeBloqueou, setQuemMeBloqueou] = useState([]);

  // Quem está mesmo dentro de uma batalha, lido da coleção das batalhas.
  // Mapa: uid do jogador -> id da batalha onde ele está.
  const [batalhasPorUid, setBatalhasPorUid] = useState({});

  // PERFIL SOBREPOSTO À BATALHA (mantém o JogoPK montado por baixo, sem cortar o Agora)
  const [perfilSobreBatalha, setPerfilSobreBatalha] = useState(null);
  const [abaGrelha, setAbaGrelha] = useState('videos');
  const [presenteAtivo, setPresenteAtivo] = useState(null);
  const [idPostAtivo, setIdPostAtivo] = useState(null);

  useEffect(() => {
    // Ao voltar ao lobby não pode sobrar nenhuma câmara acesa de uma partida
    // anterior. Fecha tudo o que ainda esteja vivo (ver agoraSession.js).
    terminarTodasAsSessoes().catch(() => {});

    // QUEM ENTRA COM um batalhaId que NÃO é o seu é um ESPECTADOR (veio do Feed/TV ou
    // de uma notificação). Esse não deve marcar-se "emLive" nem avisar os seguidores —
    // senão o adepto aparecia no mosaico como se estivesse a lutar e disparava pushes
    // de "entrou em batalha" para os seus seguidores. Só o anfitrião faz isso.
    const entrouComoEspectador = !!batalhaId && batalhaId !== auth.currentUser?.uid;

    if (!entrouComoEspectador) {
      // Entra na Arena e fica Online
      updateDoc(doc(db, "utilizadores", auth.currentUser.uid), { emLive: true });

      // AVISAR SEGUIDORES QUE ENTREI NA ARENA
      const avisarSeguidores = async () => {
        const seguidoresRef = collection(db, "utilizadores", auth.currentUser.uid, "seguidores");
        const snap = await getDocs(seguidoresRef);
        snap.forEach((docSeguidor) => {
          // Preservada a sua função de notificações nativas intacta
          try {
            enviarNotificacao(
              docSeguidor.id,
              auth.currentUser.uid,
              auth.currentUser.displayName || "Um craque",
              "arena_pk",
              { batalhaId: auth.currentUser.uid }
            );
          } catch(e) {}
          dispararPushNoBolso(docSeguidor.id, "GAME FUT LIVE", `${auth.currentUser.displayName || "Um craque"} entrou em batalha! Vem apoiar!`);
        });
      };
      avisarSeguidores();
    }

    // ESCUTADOR DE BLOQUEADOS (PARA FILTRAR A ARENA)
    const unsubMeusBloqueados = onSnapshot(collection(db, "utilizadores", auth.currentUser.uid, "bloqueados"), (snap) => {
      setMeusBloqueados(snap.docs.map(d => d.id));
    });

    // ESCUTADOR DE QUEM ME BLOQUEOU (ARENA) - Versão Segura
    const unsubDeles = onSnapshot(collectionGroup(db, "bloqueados"), (snap) => {
      const ids = [];
      snap.forEach(doc => {
        if (doc.id === auth.currentUser?.uid) {
          ids.push(doc.ref.parent.parent.id);
        }
      });
      setQuemMeBloqueou(ids);
    });

    const unsub = onSnapshot(doc(db, "utilizadores", auth.currentUser.uid), (docSnap) => {
      if (docSnap.exists()) {
        const dados = docSnap.data();
        setMeusDados(dados);
        
        // CORREÇÃO DA BLINDAGEM: Só ativa o Jogo se o ID for válido e o status for exatamente 'aceite'
        if (dados.convitePK?.status === 'aceite' && !modoEspectador && dados.convitePK?.idBatalha) {
           setBatalhaAtiva(dados.convitePK.idBatalha);
        }
      }
    });

    return () => {
      if (!entrouComoEspectador) {
        updateDoc(doc(db, "utilizadores", auth.currentUser.uid), { emLive: false });
      }
      unsub();
      unsubDeles();
      unsubMeusBloqueados();
    };

  }, [modoEspectador]);

  // ANTENA DAS BATALHAS EM CURSO.
  // O mosaico decidia quem estava a jogar pelo `convitePK` de cada utilizador.
  // Esse campo é um convite, não o estado da partida — e é limpo em vários
  // sítios (ao sair, ao fechar a batalha, na limpeza dos convites fantasma).
  // Resultado: quem estava mesmo a jogar aparecia como livre, sem botão
  // ASSISTIR, e para lá voltar era preciso sair da Arena e entrar de novo.
  //
  // A verdade está na coleção das batalhas, e é de lá que passa a vir.
  useEffect(() => {
    const FASES_VIVAS = [
      "ESPERA", "1ª PARTE", "INTERVALO", "2ª PARTE",
      "PROLONGAMENTO_1", "PROLONGAMENTO_2", "PENALTIS",
    ];
    const q = query(collection(db, "batalhasAtivas"), where("fase", "in", FASES_VIVAS));

    const unsub = onSnapshot(q, (snap) => {
      const mapa = {};
      snap.forEach((documento) => {
        const dados = documento.data() || {};
        const entrada = { id: documento.id, fase: dados.fase };
        if (dados.idA) mapa[dados.idA] = entrada;
        if (dados.idB) mapa[dados.idB] = entrada;
      });
      setBatalhasPorUid(mapa);
    }, (erro) => console.log("Antena de batalhas:", erro));

    return () => unsub();
  }, []);

  useEffect(() => {
    // Monitoriza todos os utilizadores na Arena
    const q = query(collection(db, "utilizadores"), where("emLive", "==", true));
    const unsub = onSnapshot(q, (snap) => {
      setUtilizadoresOnline(snap.docs.map(d => ({ uid: d.id, ...d.data() })).filter(u => u.uid !== auth.currentUser.uid && !meusBloqueados.includes(u.uid) && !quemMeBloqueou.includes(u.uid)));
    });
    return () => unsub();
  }, [meusBloqueados, quemMeBloqueou]);

  // VOLTAR À PARTIDA QUE FICOU A MEIO.
  // Depois de um jogo acabar, o convitePK é limpo — e era só por ele que a
  // Arena sabia levar alguém de volta ao campo. Quem tivesse uma partida a
  // decorrer ficava parado no mosaico e tinha de sair e entrar outra vez.
  // Agora basta estar numa batalha a jogar para ser reposto lá dentro.
  //
  // Só nas fases DE JOGO: em ESPERA a pessoa ainda pode querer andar pelo
  // mosaico, e trancá-la no ecrã da batalha seria pior do que o problema.
  useEffect(() => {
    if (batalhaAtiva || modoEspectador) return;
    const minhaBatalha = batalhasPorUid[auth.currentUser?.uid];
    if (!minhaBatalha || minhaBatalha.fase === "ESPERA" || minhaBatalha.fase === "FIM") return;
    setBatalhaAtiva(minhaBatalha.id);
  }, [batalhasPorUid, batalhaAtiva, modoEspectador]);

  useEffect(() => {
    // Se a Márcia vier de uma notificação, o batalhaId do Miguel estará aqui
    if (batalhaId && batalhaId !== auth.currentUser?.uid) {
      setModoEspectador(true);
      setBatalhaAtiva(batalhaId);
    }
  }, [batalhaId]);

  // HOOK GLOBAL DE NAVEGAÇÃO DO PERFIL NA ARENA PK.
  // A lista de adeptos (Viewer List Modal) e o chat da batalha disparam o evento
  // 'abrirPerfilUsuario' com o UID do utilizador. Aqui apanhamos esse alarme, vamos
  // buscar os dados reais ao Firestore e sobrepomos o perfil POR CIMA da batalha.
  // O JogoPK permanece montado por baixo, por isso a ligação Agora (áudio/vídeo)
  // NUNCA cai — o botão "RETURN TO BATTLE" apenas fecha a sobreposição.
  useEffect(() => {
    const aoPedirPerfil = async (e) => {
      const userId = e?.detail;
      if (!userId) return;
      try {
        const { doc: fDoc, getDoc: fGetDoc } = await import('firebase/firestore');
        const snap = await fGetDoc(fDoc(db, "utilizadores", userId));
        const userData = { uid: userId, ...(snap.exists() ? snap.data() : {}) };
        setPerfilSobreBatalha(userData);
      } catch (errPerfil) {
        console.error("Erro ao abrir perfil sobre a batalha:", errPerfil);
      }
    };

    window.addEventListener('abrirPerfilUsuario', aoPedirPerfil);
    return () => window.removeEventListener('abrirPerfilUsuario', aoPedirPerfil);
  }, []);

    const enviarDesafio = async (rival) => {
    const idBatalha = auth.currentUser.uid; 
    
    // Alinha a fase inicial e limpa os estados fantasmas antes do JogoPK arrancar
    await setDoc(doc(db, "batalhasAtivas", idBatalha), {
      pontosA: 0, pontosB: 0, 
      golosA: 0, golosB: 0,
      prontoA: false, prontoB: false, 
      fase: "ESPERA", 
      idA: auth.currentUser.uid, 
      idB: rival.uid, 
      nomeA: meusDados.nomeCompleto || meusDados.displayName || "Miguel", 
      nomeB: rival.nomeCompleto || rival.displayName || "Márcia",
      fotoA: meusDados.fotoUrl || meusDados.fotoURL || '',
      fotoB: rival.fotoUrl || rival.fotoURL || '',
      ultimoVideo: null,
      timestampCriacao: serverTimestamp()
    });

    await updateDoc(doc(db, "utilizadores", rival.uid), {
      convitePK: { de: auth.currentUser.uid, nome: meusDados.nomeCompleto || meusDados.displayName || "Miguel", status: 'pendente', idBatalha: idBatalha }
    });

    await updateDoc(doc(db, "utilizadores", auth.currentUser.uid), {
      convitePK: { status: 'aguardando', idBatalha: idBatalha }
    });
  };

    const aceitarPK = async () => {
    const id = meusDados?.convitePK?.idBatalha;
    if (!id) return;

    try {
      // TRAVA DE AQUECIMENTO: Congela o jogo em ESPERA para dar tempo de partilhar!
      await updateDoc(doc(db, "batalhasAtivas", id), {
        fase: "ESPERA",
        prontoA: false,
        prontoB: false,
        pontosA: 0,
        pontosB: 0,
        golosA: 0,
        golosB: 0
      });

      await updateDoc(doc(db, "utilizadores", auth.currentUser.uid), { "convitePK.status": 'aceite' });
      await updateDoc(doc(db, "utilizadores", meusDados.convitePK.de), { "convitePK.status": 'aceite' });
    } catch (errAceitar) {
      console.error("Erro ao sincronizar aceitação:", errAceitar);
    }
  };

  // ESTA FUNÇÃO É O SEU BOTÃO SALVADOR: Executa o fecho ou reset de jogo sem disparar rotas erradas
  const fecharOuResetarBatalha = async () => {
    try {
      if (!modoEspectador && auth.currentUser) {
        // Limpa o convitePK no Firestore para que na próxima batalha a app saiba que é um recomeço do zero
        await updateDoc(doc(db, "utilizadores", auth.currentUser.uid), {
          convitePK: null
        });
      }
    } catch(e) { console.log(e); }
    setBatalhaAtiva(null);
  };

  // Apaga o convitePK que ficou preso a uma batalha já terminada. É isto que
  // faz o botão ASSISTIR desaparecer do mosaico em vez de ficar a apontar para
  // um jogo que já não existe.
  const limparConviteFantasma = async (idBatalha, dadosBatalha) => {
    try {
      const { doc: fDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');
      // Sem documento, o dono da batalha é o próprio id (é assim que a Arena
      // os cria: idBatalha === uid de quem desafia).
      const envolvidos = dadosBatalha
        ? [dadosBatalha.idA, dadosBatalha.idB]
        : [idBatalha];
      for (const uid of envolvidos) {
        if (!uid) continue;
        await fUpdateDoc(fDoc(db, "utilizadores", uid), { convitePK: null }).catch(() => {});
      }
    } catch (err) {
      console.log("Não foi possível limpar o convite fantasma:", err);
    }
  };

    const assistirBatalha = async (idBatalha) => {
    try {
      const { doc: fDoc, getDoc: fGetDoc } = await import('firebase/firestore');
      // Valida na hora se o utilizador está na lista negra desta batalha
      const banSnap = await fGetDoc(fDoc(db, "batalhasAtivas", idBatalha, "expulsos", auth.currentUser.uid));
      
      if (banSnap.exists()) {
        alert("Acesso recusado! Foste expulso deste estádio! 🟥");
        return; // Trava a entrada aqui e não abre o jogo
      }

      // A BATALHA AINDA EXISTE? O mosaico decide o botão ASSISTIR pelo
      // convitePK do utilizador, que pode ficar para trás se alguém fechar o
      // separador a meio. Sem esta validação, entrava-se numa partida acabada
      // — com o cronómetro parado e duas janelas pretas.
      const batalhaSnap = await fGetDoc(fDoc(db, "batalhasAtivas", idBatalha));
      const dados = batalhaSnap.exists() ? batalhaSnap.data() : null;

      if (!dados || dados.fase === "FIM") {
        alert("Esta batalha já terminou! 🏁");
        await limparConviteFantasma(idBatalha, dados);
        return;
      }
    } catch (errCheck) { console.log(errCheck); }

    // Se não estiver banido, entra normalmente no jogo
    setModoEspectador(true);
    setBatalhaAtiva(idBatalha);
  };

  const utilizadoresFiltrados = utilizadoresOnline.filter(u => {
    const cumpreBloqueio = !meusBloqueados.includes(u.uid) && !quemMeBloqueou.includes(u.uid);
    const termo = pesquisaArena ? pesquisaArena.toLowerCase().trim() : '';
    const nomeMatches = !termo || u.nomeCompleto?.toLowerCase().includes(termo) || u.displayName?.toLowerCase().includes(termo);
    return cumpreBloqueio && nomeMatches;
  });

  // Se houver batalha ativa, renderiza o JogoPK passando a nossa nova função segura de desengate
    if (batalhaAtiva) {
    return (
      <>
        <JogoPK
          idBatalha={batalhaAtiva}
          idA={batalhaAtiva}
          espectador={modoEspectador}
          aoSair={fecharOuResetarBatalha}
        />

        {/* PERFIL DO ADEPTO SOBREPOSTO À BATALHA */}
        {perfilSobreBatalha && (
          <div style={{ position: 'fixed', inset: 0, zIndex: 2000000, backgroundColor: '#000', overflowY: 'auto' }}>
            <button
              onClick={() => setPerfilSobreBatalha(null)}
              style={{ position: 'fixed', top: '45px', left: '15px', zIndex: 2000001, background: '#39FF14', color: '#000', border: 'none', borderRadius: '20px', padding: '8px 16px', fontWeight: '900', fontSize: '13px', cursor: 'pointer', boxShadow: '0 0 12px rgba(57,255,20,0.5)' }}
            >
              ← RETURN TO BATTLE
            </button>
            <Perfil
              userDados={perfilSobreBatalha}
              abaGrelha={abaGrelha}
              setAbaGrelha={setAbaGrelha}
              postsDoFeed={[]}
              darLike={() => {}}
              presenteAtivo={presenteAtivo}
              setPresenteAtivo={setPresenteAtivo}
              setMostrarPresentes={() => {}}
              setIdPostAtivo={setIdPostAtivo}
            />
          </div>
        )}
      </>
    );
  }

  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh', color: 'white', padding: '15px', textAlign: 'center', paddingBottom: '90px' }}>

            {/* CABEÇALHO */}
      <div style={{ marginBottom: '15px' }}>
        <h2 style={{ color: '#39FF14', fontWeight: '900', margin: '0', fontSize: '24px', letterSpacing: '1px' }}>
          ARENA PK ⚽
        </h2>
      </div>

      {/* CAIXA DE PESQUISA NÉON UNIVERSAL */}
      <div style={{ marginBottom: '20px', padding: '0 5px' }}>
        <input 
          type="text"
          value={pesquisaArena}
          onChange={(e) => setPesquisaArena(e.target.value)}
          placeholder="Procurar craques na Arena..."
          style={{ 
            width: '100%', 
            backgroundColor: '#111', 
            border: '1px solid #333', 
            color: 'white', 
            padding: '12px 18px', 
            borderRadius: '50px', 
            fontSize: '14px', 
            outline: 'none',
            boxSizing: 'border-box'
          }}
        />
      </div>

      {/* BOX DE CONVITE RECEBIDO */}
      {meusDados?.convitePK?.status === 'pendente' && (
        <div style={{ background: '#fff', color: '#000', padding: '15px', borderRadius: '15px', margin: '10px 0', boxShadow: '0 0 20px #39FF14' }}>
          <p style={{ fontSize: '14px', margin: '0 0 10px 0' }}><b>{meusDados.convitePK.nome}</b> desafiou-te!</p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button onClick={aceitarPK} style={{ background: '#39FF14', padding: '10px 20px', borderRadius: '8px', border: 'none', fontWeight: '900', cursor: 'pointer' }}>ACEITAR</button>
            <button onClick={async () => {
                const rivalId = meusDados?.convitePK?.de;
                const idBat = meusDados?.convitePK?.idBatalha;
                // Ao recusar, limpa tudo de forma síncrona
                await updateDoc(doc(db, "utilizadores", auth.currentUser.uid), { convitePK: null });
                if (rivalId) { await updateDoc(doc(db, "utilizadores", rivalId), { convitePK: null }).catch(() => {}); }
                if (idBat) { await deleteDoc(doc(db, "batalhasAtivas", idBat)).catch(() => {}); }
              }} style={{ background: '#ff4444', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}>RECUSAR</button>
          </div>
        </div>
      )}

      {/* MOSAICO 4 COLUNAS */}
      {utilizadoresFiltrados.length === 0 ? (
        <div style={{ padding: '50px 20px', color: '#666', fontSize: '15px', fontWeight: 'bold' }}>
          Nenhum craque em campo neste momento... 🏟️😴
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px', marginTop: '10px' }}>
          {utilizadoresFiltrados.map(u => {
            // A batalha real manda; o convitePK fica como recurso, para o
            // caso de a antena ainda não ter chegado.
            const batalhaDele = batalhasPorUid[u.uid];
            const idBatalhaDele = batalhaDele?.id || u.convitePK?.idBatalha;
            const emJogo = !!batalhaDele || u.convitePK?.status === 'aceite';
            return (
              <div key={u.uid} style={{ 
                background: '#111', borderRadius: '12px', padding: '8px 4px', 
                display: 'flex', flexDirection: 'column', alignItems: 'center', 
                border: emJogo ? '1px solid #ff4444' : '1px solid #222',
                opacity: (u.convitePK?.status === 'aguardando') ? 0.5 : 1
              }}>
                {/* CÍRCULO DINÂMICO (VERDE OU VERMELHO) */}
                <div style={{ 
                  width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#222', marginBottom: '6px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', 
                  border: emJogo ? '2px solid #ff4444' : '2px solid #39FF14', 
                  overflow: 'hidden', boxShadow: emJogo ? '0 0 10px #ff4444' : 'none'
                }}>
                  {(u.fotoURL || u.fotoUrl) ? (
                    <img src={u.fotoURL || u.fotoUrl} alt="P" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <span style={{ fontSize: '16px' }}>👤</span>
                  )}
                </div>

                {/* NOME COMPACTO BLINDADO */}
                <span style={{ fontSize: '8px', fontWeight: 'bold', marginBottom: '8px', color: '#eee', textAlign: 'center', height: '20px', overflow: 'hidden', lineHeight: '1' }}>
                  {u.nomeCompleto?.split(' ')[0]}
                </span>

                {/* BOTÃO DINÂMICO (PK OU ASSISTIR) */}
                {emJogo ? (
                  <button 
                    onClick={() => assistirBatalha(idBatalhaDele)}
                    style={{ background: '#ff4444', border: 'none', width: '100%', borderRadius: '10px', fontSize: '7px', fontWeight: '900', color: 'white', padding: '5px 0', cursor: 'pointer' }}
                  >
                    ASSISTIR
                  </button>
                ) : (
                  <button 
                    onClick={() => enviarDesafio(u)} 
                    disabled={u.convitePK?.status === 'aguardando'}
                    style={{ 
                      background: u.convitePK?.status === 'aguardando' ? '#444' : '#39FF14', 
                      border: 'none', width: '100%', borderRadius: '10px', fontSize: '9px', fontWeight: '900', 
                      color: 'black', padding: '6px 0', cursor: 'pointer' 
                    }}
                  >
                    {u.convitePK?.status === 'aguardando' ? '...' : 'PK'}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* BARRA DE NAVEGAÇÃO FIXA NO FUNDO */}
      <div style={{ 
        position: 'fixed', bottom: 0, left: 0, right: 0, height: '75px', 
        backgroundColor: '#111', borderTop: '1px solid #333', 
        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 
      }}>
        <button 
          onClick={async () => {
            // 1. Limpa o estado de Live para a foto sumir do mosaico
            await updateDoc(doc(db, "utilizadores", auth.currentUser.uid), { 
              emLive: false, convitePK: null 
            });

            // 2. LIMPEZA TOTAL DO CHAT DESTA SESSÃO
            try {
              const chatRef = collection(db, "chatsArena", auth.currentUser.uid, "chat");
              const snapChat = await getDocs(query(chatRef));
              const delecoes = snapChat.docs.map(d => deleteDoc(d.ref));
              await Promise.all(delecoes);
            } catch (e) { console.log("Chat já limpo"); }

    // 3. Dispara o encerramento do ecrã da Arena de forma nativa e sem F5
                                  if (typeof aoSair === 'function') {
            aoSair();
          } else {
            // Chuta para a rota principal limpa sem forçar o recarregamento do ecrã de som
            window.location.replace('/?app');
          }
          }}
          style={{ background: 'none', border: 'none', color: '#39FF14', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
        >
          <span style={{ fontSize: '26px', marginBottom: '4px' }}>👤</span>
          <span style={{ fontSize: '10px', fontWeight: '900', letterSpacing: '1px' }}>VOLTAR AO FEED</span>
        </button>
      </div>

    </div>
  );
}

export default ArenaPK;


